export const listSteps = `
   query listSteps($filter: StepsFilterInput, $limit: Int, $nextToken: String) {
       listSteps(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              phaseId
              phase {
                id
                name
                displayName
              }
              playbookId
              name
              displayName
              description
              position
              taskStateName
              targetService
              targetOperation
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getStep = `
   query getStep($id:ID!) {
       getStep(id:$id) {
         id
         phaseId
         phase {
           id
           name
           displayName
         }
         playbookId
         name
         displayName
         description
         position
         taskStateName
         targetService
         targetOperation
         createdByUsername
         created
         updated
       }
}`;
